import e, { createContext as t, createElement as n, forwardRef as r, useCallback as i, useEffect as a, useImperativeHandle as o, useLayoutEffect as s, useMemo as c, useRef as l, useState as u } from "react";
import { useFactory as d, useInstance as f, useResources as p, useRouter as m, useSearchParams as h, useSignal as g, useStrictContext as _, useStrictInstance as v } from "@funtech-int/rival-react";
import { createFlags as y, createRef as b, createResourceQuery as ee, createSignal as x } from "@funtech-int/rival";
import { Fragment as S, jsx as C, jsxs as w } from "react/jsx-runtime";
import { stringifyUrl as T } from "query-string";
import { useIntl as E } from "react-intl";
import { createPortal as te } from "react-dom";
import { GeoWidgetTriggerWrapper as ne } from "@funtech-int/i18n-geo-widget/lazy";
import { RequestIdsHeader as D, clientRequestIdParser as re, createRequestIdFactory as ie, getRequestId as ae, serverRequestIdParser as oe } from "@kinopoisk-int/request-ids";
import { Offers as se, PWTools as ce, WidgetRouterWeb as le } from "@plus-int/acq-toolkit";
import { useStorage as ue } from "@funtech-int/web-toolkit";
import { Dcb as de } from "@plus-int/acq-toolkit/dcb";
//#region \0rolldown/runtime.js
var fe = Object.defineProperty, pe = (e, t) => {
	let n = {};
	for (var r in e) fe(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || fe(n, Symbol.toStringTag, { value: "Module" }), n;
};
//#endregion
//#region src/lib/analytics.ts
function me(e) {
	if (!e) throw Error("Evgen is not initialized");
}
function he(e) {
	let t = /* @__PURE__ */ new Set();
	function n(t, n, r) {
		return me(e), r?.namespace ? t(e, r.namespace, n) : t(e, n);
	}
	return {
		send: n,
		sendOnce(e, r, i) {
			let a = i?.key ?? JSON.stringify(r);
			t?.has(a) || (t?.add(a), n(e, r, i));
		}
	};
}
//#endregion
//#region ../../../../../../../../../../.nots/pnpm_store/v10/links/@kinopoisk-int/evgen-web-events/1.362.0/2dbe9843561c7ebff2c1aa10126c144bb664b72c33abf64664d34327c55354ae/node_modules/@kinopoisk-int/evgen-web-events/web/evgen_analytics.ts
var ge = /* @__PURE__ */ function(e) {
	return e.Android = "android", e.Ios = "ios", e.AndroidTv = "android_tv", e.HarmonyTv = "harmony_tv", e.ZeasnTv = "zeasn_tv", e.YandexTv = "yandex_tv", e.Tvos = "tvos", e.Tizen = "tizen", e.Orsay = "orsay", e.Webos = "webos", e.Playstation4 = "playstation4", e.Playstation5 = "playstation5", e.Xbox = "xbox", e.Web = "web", e.AospTv = "aosp_tv", e.Vidaa = "vidaa", e.Tvip = "tvip", e.Mina = "mina", e.Visionos = "visionos", e;
}({}), _e = /* @__PURE__ */ function(e) {
	return e.Yes = "yes", e.No = "no", e;
}({}), ve = /* @__PURE__ */ function(e) {
	return e.DefaultRegion = "default_region", e.Ip = "ip", e.Geo = "geo", e.Manual = "manual", e;
}({}), ye = /* @__PURE__ */ function(e) {
	return e.Ltr = "ltr", e.Rtl = "rtl", e.NotSupported = "not_supported", e;
}({});
function be(e, t, n) {
	return { trackEvent: (r, i) => {
		let a = {
			...i,
			...t.getGlobalParams(),
			...n.getPlatformParams()
		};
		e.trackEvent(r, a);
	} };
}
//#endregion
//#region src/lib/tracking.ts
var xe = "service-id", Se = class {
	logger;
	apiUrl;
	serviceId;
	constructor({ trackingBaseUrl: e, serviceId: t, logger: n }) {
		this.apiUrl = `${e}/watch-batch`, this.serviceId = t, this.logger = n;
	}
	trackEvent(e, t) {
		let n = JSON.stringify([{
			...t,
			eventName: e
		}]);
		return navigator.sendBeacon && window.Blob && navigator.sendBeacon(this.apiUrl, new Blob([n], { type: "application/json" })) ? Promise.resolve() : fetch(this.apiUrl, {
			body: n,
			method: "POST",
			...this.serviceId ? { headers: { [xe]: String(this.serviceId) } } : {}
		}).catch((e) => {
			this.logger?.error({ error: e }, "Failed to track EvGen analytics data"), e instanceof Error && this.logger?.error({ error: e }, e.message);
		});
	}
}, Ce = class {
	providers;
	constructor({ providers: e }) {
		this.providers = e;
	}
	trackEvent(e, t) {
		this.providers.forEach((n) => n.trackEvent(e, t));
	}
}, we = class {
	provider;
	constructor(e) {
		this.provider = e;
	}
	trackEvent(e, t) {
		this.provider.trackEvent(e, t);
	}
};
function Te(e) {
	return [
		`%c[Evgen]%c %c[trackEvent]%c %c[${e}]`,
		"color: #fff; font-weight: bold; background: #194B77",
		null,
		"color: #fff; background: #806d3e",
		null,
		"color: #fff; background: #4f4473"
	];
}
var Ee = class extends we {
	logger = console;
	hasDebugCookie = document.cookie.includes("_kp_debug=");
	constructor(e, t = Te) {
		super(e), this.getEventMessageHeader = t;
	}
	trackEvent(e, t) {
		this.hasDebugCookie && this.logger.debug(...this.getEventMessageHeader(e), t), super.trackEvent(e, t);
	}
}, O = b("evgen"), De = "unauthorized", Oe = "no–subscriptions", ke = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content"
];
function k(e) {
	return e ?? "-";
}
function Ae(e, t) {
	return { getPlatformParams() {
		return {
			appVersion: e,
			yandexuid: k(t),
			referer: k(document.referrer),
			url: window.location.href
		};
	} };
}
function je({ featureFlags: e, authManager: t, trackedQueryParamsStore: n, locale: r, runtimeConfig: i, serviceName: a, sessionIds: o }) {
	return { getGlobalParams() {
		let s = n.getParams(ke), c = t.userProfile?.billingFeatureNames, { isAuthorized: l } = t;
		return c?.length || (c = l ? [Oe] : [De]), {
			experimentsFilter: {},
			deviceId: "-",
			platformName: ge.Web,
			osVersion: "-",
			cityName: "-",
			regionSource: ve.Ip,
			subscriptionType: "-",
			globalSessionId: k(o?.globalSessionId),
			localSessionId: k(o?.localSessionId.get()),
			featureToggles: {},
			experiments: e.grouped,
			regionId: k(String(i.regionId)),
			kpuid: "-",
			auth: l ? _e.Yes : _e.No,
			subprofileId: "-",
			childMode: !1,
			puid: t?.userProfile?.puid ? String(t?.userProfile.puid) : "-",
			billingFeatureNames: c,
			utmCampaign: k(s.utm_campaign),
			utmMedium: k(s.utm_medium),
			utmSource: k(s.utm_source),
			serviceName: a,
			lang: r.lang,
			textDirection: r.dir === "ltr" ? ye.Ltr : ye.Rtl,
			eventTimestamp: Date.now().toString()
		};
	} };
}
function Me({ featureFlags: e, logger: t, authManager: n, trackedQueryParamsStore: r, locale: i, runtimeConfig: a, serviceName: o, sessionIds: s, appVersion: c, yandexuid: l, trackingsHost: u, metrikaProvider: d }) {
	let f = Ae(c, l), p = je({
		featureFlags: e,
		authManager: n,
		trackedQueryParamsStore: r,
		locale: i,
		runtimeConfig: a,
		serviceName: o,
		sessionIds: s
	});
	return {
		...be(new Ee(new Ce({ providers: [new Se({
			trackingBaseUrl: u,
			logger: t
		}), d] })), p, f),
		ref: () => O
	};
}
//#endregion
//#region src/hooks/useEvgen.ts
function Ne() {
	return f(O);
}
//#endregion
//#region src/components/AnalyticsSenderProvider/AnalyticsSenderContext.ts
var Pe = t(null), Fe = ({ children: e }) => {
	let t = Ne(), n = d(() => he(t));
	return /* @__PURE__ */ C(Pe.Provider, {
		value: n,
		children: e
	});
};
//#endregion
//#region src/hooks/useAnalytics.ts
function Ie(e) {
	let t = _(Pe);
	return d(() => e(t));
}
//#endregion
//#region src/lib/fromBlock.ts
var Le = "deviceUuid";
function Re(e) {
	return e.local.get(Le) ?? void 0;
}
function ze(e) {
	return `${Re(e)}_${Date.now()}`;
}
var Be = b("fromBlock"), Ve = (e) => {
	let t = ze(e), n = 0, r = x(`${t}_${n}`);
	return {
		get sessionIds() {
			return {
				globalSessionId: t,
				localSessionId: r.seal()
			};
		},
		updateSession() {
			n += 1, r.set(`${t}_${n}`);
		},
		ref() {
			return Be;
		}
	};
};
//#endregion
//#region src/hooks/useFromBlock.ts
function He() {
	return v(Be);
}
function Ue(t) {
	let n = He();
	e.useEffect(() => {
		t && n && n.updateSession();
	}, [t, n]);
}
//#endregion
//#region src/components/SeoDefaultContext/SeoDefaultContext.ts
var We = t(null), A = () => _(We), Ge = ({ url: e, lang: t, host: n, queryParams: r = {} }) => T({
	url: `${n}/${t}${e}`,
	query: r
}), Ke = ({ url: e, locales: t, host: n, queryParams: r = {} }) => t.map((t) => ({
	href: T({
		url: `${n}/${t}${e}`,
		query: r
	}),
	hreflang: t
})), j = (e) => {
	let { currentLang: t } = A();
	return m().serialize(e)?.replace(RegExp(`^/${t}`), "");
}, qe = ({ seoTitle: e, seoDescription: t, location: n, queryParams: r }) => {
	let i = A(), { Head: a, FaviconLinks: o } = i, s = j(n), c = Ge({
		url: s,
		lang: i.currentLang,
		host: i.hostOrigin,
		queryParams: r
	}), l = Ke({
		url: s,
		locales: i.locales,
		host: i.hostOrigin,
		queryParams: r
	});
	return /* @__PURE__ */ w(S, { children: [/* @__PURE__ */ w(a, { children: [
		/* @__PURE__ */ C("title", { children: e }, "title"),
		/* @__PURE__ */ C("meta", {
			name: "description",
			content: t
		}),
		/* @__PURE__ */ C("link", {
			rel: "canonical",
			href: c
		}, "canonical"),
		l.map(({ href: e, hreflang: t }) => /* @__PURE__ */ C("link", {
			rel: "alternate",
			href: e,
			hrefLang: t
		}, `${t}_alternate`))
	] }), /* @__PURE__ */ C(o, {})] });
}, Je = ({ location: e, ogTitle: t, ogDescription: n, ogImage: r, ogImageWidth: i, ogImageHeight: a, ogImageAlt: o, ogType: s, queryParams: c }) => {
	let l = A(), u = j(e), { Head: d } = l, f = r || l.seoImage.url, p = i || l.seoImage.width, m = a || l.seoImage.height, h = Ge({
		url: u,
		lang: l.currentLang,
		host: l.hostOrigin,
		queryParams: c
	});
	return /* @__PURE__ */ w(d, { children: [
		/* @__PURE__ */ C("meta", {
			property: "og:site_name",
			content: l.seoSiteName
		}, "og:site_name"),
		/* @__PURE__ */ C("meta", {
			property: "og:type",
			content: s
		}, "og:type"),
		/* @__PURE__ */ C("meta", {
			property: "og:title",
			content: t
		}, "og:title"),
		/* @__PURE__ */ C("meta", {
			property: "og:description",
			content: n
		}, "og:description"),
		/* @__PURE__ */ C("meta", {
			property: "og:url",
			content: h
		}, "og:url"),
		/* @__PURE__ */ C("meta", {
			property: "og:image",
			content: f
		}, "og:image"),
		/* @__PURE__ */ C("meta", {
			property: "og:image:width",
			content: String(p)
		}, "og:image:width"),
		/* @__PURE__ */ C("meta", {
			property: "og:image:height",
			content: String(m)
		}, "og:image:height"),
		!!o && /* @__PURE__ */ C("meta", {
			property: "og:image:alt",
			content: o
		}, "og:image:alt")
	] });
}, Ye = (e) => /* @__PURE__ */ C(Je, {
	...e,
	ogType: "website"
}), Xe = ({ ogVideoDuration: e, ogVideoTags: t, ...n }) => {
	let { Head: r } = A();
	return /* @__PURE__ */ w(S, { children: [/* @__PURE__ */ C(Je, {
		...n,
		ogType: "video.movie"
	}), /* @__PURE__ */ w(r, { children: [!!e && /* @__PURE__ */ C("meta", {
		property: "video:duration",
		content: String(e)
	}, "video:duration"), !!t && t?.map((e) => /* @__PURE__ */ C("meta", {
		property: "og:video:tag",
		content: e
	}, e))] })] });
}, Ze = ({ twitterCard: e = "summary_large_image", twitterImage: t, twitterDescription: n }) => {
	let r = A(), { Head: i } = r, a = t || r.seoImage.url;
	return /* @__PURE__ */ w(i, { children: [
		/* @__PURE__ */ C("meta", {
			name: "twitter:card",
			content: e
		}),
		/* @__PURE__ */ C("meta", {
			name: "twitter:image",
			content: a
		}, "twitter:image"),
		/* @__PURE__ */ C("meta", {
			property: "twitter:description",
			content: n
		}, "twitter:description")
	] });
}, Qe = ({ scripts: e = [] }) => {
	let { Head: t } = A();
	return /* @__PURE__ */ C(t, { children: e.map(({ id: e, data: t }) => /* @__PURE__ */ n("script", {
		...t,
		key: e
	})) });
}, $e = (e) => ({
	icon: `${e}/favicon.ico`,
	svg: `${e}/favicon.svg`,
	appleTouchIcon: `${e}/apple-touch-icon.png`,
	appleTouchIcon152: `${e}/apple-touch-icon-152x152.png`,
	appleTouchIcon167: `${e}/apple-touch-icon-167x167.png`,
	appleTouchIcon180: `${e}/apple-touch-icon-180x180.png`
}), et = () => {
	let { Head: e, hostOrigin: t } = A(), n = $e(t ?? "");
	return /* @__PURE__ */ w(e, { children: [
		/* @__PURE__ */ C("link", {
			rel: "icon",
			href: n.icon,
			sizes: "16x16 32x32 48x48",
			type: "image/x-icon"
		}),
		/* @__PURE__ */ C("link", {
			rel: "icon",
			href: n.svg,
			sizes: "any",
			type: "image/svg+xml"
		}),
		/* @__PURE__ */ C("link", {
			rel: "apple-touch-icon",
			href: n.appleTouchIcon
		}),
		/* @__PURE__ */ C("link", {
			rel: "apple-touch-icon",
			sizes: "152x152",
			href: n.appleTouchIcon152
		}),
		/* @__PURE__ */ C("link", {
			rel: "apple-touch-icon",
			sizes: "167x167",
			href: n.appleTouchIcon167
		}),
		/* @__PURE__ */ C("link", {
			rel: "apple-touch-icon",
			sizes: "180x180",
			href: n.appleTouchIcon180
		})
	] });
}, tt = ({ links: e }) => {
	let { Head: t } = A();
	return /* @__PURE__ */ C(t, { children: e.map((e) => /* @__PURE__ */ C("link", {
		rel: "preload",
		...e
	}, e.href)) });
}, nt = ({ seoDefaultValues: e, children: t }) => /* @__PURE__ */ C(We.Provider, {
	value: e,
	children: t
}), rt = /* @__PURE__ */ pe({
	BasicMeta: () => qe,
	FaviconLinks: () => et,
	OgVideoMeta: () => Xe,
	OgWebsiteMeta: () => Ye,
	PreloadLinks: () => tt,
	Provider: () => nt,
	StructuredData: () => Qe,
	TwitterMeta: () => Ze
}), it = {
	home_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.c9ca44c0776e1a7a35219eb3c29b1842" }, { brandName: t }),
	home_seo_description: (e) => e.formatMessage({ id: "yango-shared.i18n.c3ee1bbda67aef5101a6a3b5eaeea26e" }),
	music_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.247eaea9c7b59c177155adace28cd307" }, { brandName: t }),
	music_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.f119440a78b551b3d71830059cbdae0a" }),
	yasmina_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.75183bf6eff3525e541a3f5b89ea6215" }, { brandName: t }),
	yasmina_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.b272833b5b03acfc8a60a7a80702562b" }, { brandName: t }),
	crunchyroll_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.432259e6e890ffddcb9e4a0a971037e4" }, { brandName: t }),
	crunchyroll_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.d9c3467b19748eac900efdf403079e81" }),
	cari_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.00f40372932ef576ddede55ffe815fc6" }, { brandName: t }),
	cari_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.31bb5fa8d62e447960af5150adb043c9" }, { brandName: t }),
	talabat_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.69ede0a45134e1ee040e337756fe864e" }, { brandName: t }),
	talabat_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.e10f5e1d5fee3ccbc50ec44fb7676f46" }, { brandName: t }),
	settings_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.68c59d81e48e440b99a82bdcad8961a1" }, { brandName: t }),
	settings_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.9688895733f2180a01790bbedf7c587f" }, { brandName: t }),
	selection__seo_title: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.c7eb6a2b3ae99b848674ba6d9c36ed20" }, {
		title: t,
		brandName: n
	}),
	selection__meta_description: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.097c644db94478882376918ebfad27a2" }, {
		title: t,
		brandName: n
	}),
	person_seo_title: (e, { name: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.61c0cb332e69b16aea91ab6c574103bb" }, {
		name: t,
		brandName: n
	}),
	person_meta_description: (e, { name: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.4a2b1622365c1ede99f508a8d276d67b" }, {
		name: t,
		brandName: n
	}),
	movie__film_seo_title: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.7a62bce6cc9912ff858ce9fcca27d57b" }, {
		title: t,
		brandName: n
	}),
	movie__film_meta_description: (e, { title: t, yearAndCountry: n, brandName: r }) => e.formatMessage({ id: "yango-shared.i18n.8e6dad65dfae6b8e3942b7cc080213aa" }, {
		title: t,
		yearAndCountry: n,
		brandName: r
	}),
	movie__film_seo_year_and_country: (e, { ottProductionYear: t, comma: n, country: r }) => e.formatMessage({ id: "yango-shared.i18n.e992b42b390806724b27faeaaf73168d" }, {
		ottProductionYear: t,
		comma: n,
		country: r
	}),
	movie__series_seo_title: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.5093e6fda1dcfbcac8dc2566c70be304" }, {
		title: t,
		brandName: n
	}),
	movie__series_meta_description: (e, { title: t, years: n, brandName: r }) => e.formatMessage({ id: "yango-shared.i18n.11455b8a68f1719fcc4d377f81367677" }, {
		title: t,
		years: n,
		brandName: r
	}),
	channels_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.197a4c17d41a7616ff16d048a4e73281" }, { brandName: t }),
	channels_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.da762b9acab6aba6c1843a0455d7db9b" }, { brandName: t }),
	history_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.81189435bb53a57af303dc2ab7ea7473" }, { brandName: t }),
	history_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.75cd3553ced0fa9ea3c5261c3725fd64" }, { brandName: t }),
	personal_collection_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.641d5ca4a091775c74cc25366426da0e" }, { brandName: t }),
	personal_collection_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.2268bd9c28cfeb283da1c836ac0e4e6b" }),
	profiles_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.064bb4b609654f4c4161e334d06ff9a9" }, { brandName: t }),
	profiles_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.7de5a32eb16b914f8c63f98cbe48d341" }),
	admin_add_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.37ac7ab3ce71b2288486d2c8ed1fd011" }, { brandName: t }),
	admin_add_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.fcfecb380c0f126e150722e79cffa0b9" })
};
//#endregion
//#region src/lib/i18n.ts
function at(e) {
	return function() {
		let t = E();
		return i((n, r) => e[n](t, r), [t]);
	};
}
//#endregion
//#region src/hooks/useI18n.ts
var ot = at(it);
//#endregion
//#region ../../../../../../../../../../.nots/pnpm_store/v10/links/@/clsx/2.1.1/31a8239809d68b055357418aaab3ba5139c779aca23636c4138978433c48d592/node_modules/clsx/dist/clsx.mjs
function st(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = st(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function M() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = st(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region src/hooks/useOuterClick.ts
function ct(e, t, n = !0) {
	a(() => {
		if (!n) return;
		let r = (n) => {
			e.current && !e.current.contains(n.target) && t();
		};
		return document.addEventListener("mousedown", r), () => {
			document.removeEventListener("mousedown", r);
		};
	}, [
		e,
		t,
		n
	]);
}
var N = {
	root: "Tooltip_root__O-LT0",
	startAlignment: "Tooltip_startAlignment__6XNB1",
	withChevronOnLeft: "Tooltip_withChevronOnLeft___t0tr",
	tail: "Tooltip_tail__BxoUg",
	middleAlignment: "Tooltip_middleAlignment__ooNb8",
	endAlignment: "Tooltip_endAlignment__EOXAZ",
	withChevronOnRight: "Tooltip_withChevronOnRight__9h99L",
	closeButton: "Tooltip_closeButton__mkdIB",
	withChevronAtTop: "Tooltip_withChevronAtTop__QR7Bs",
	withChevronAtBottom: "Tooltip_withChevronAtBottom__x4vXH",
	secondary: "Tooltip_secondary__pLW9L",
	portal: "Tooltip_portal__60nld",
	tooltipSlideIn: "Tooltip_tooltipSlideIn__KMlL4",
	text: "Tooltip_text__jIG41"
}, lt = (e) => /* @__PURE__ */ C("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.4rem",
	height: "2.4rem",
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ C("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m2.652-13.849L12 10.303 9.349 7.65 7.65 9.35 10.303 12 7.65 14.652l1.698 1.697L12 13.697l2.652 2.652 1.697-1.697L13.697 12l2.652-2.651z",
		clipRule: "evenodd"
	})
}), ut = (e) => /* @__PURE__ */ C("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.4rem",
	height: "1rem",
	fill: "none",
	viewBox: "0 0 24 10",
	...e,
	children: /* @__PURE__ */ C("path", {
		fill: "currentColor",
		d: "M9.839 1.044c1.092-1.392 3.23-1.392 4.322 0l4.043 5.155A7.36 7.36 0 0 0 24 9v1H0V9a7.36 7.36 0 0 0 5.796-2.8z"
	})
}), P = /* @__PURE__ */ function(e) {
	return e.Text = "tooltip.text", e.CloseButton = "tooltip.closeButton", e;
}(P || {});
function dt(e) {
	return e === "start" ? "end" : e === "end" ? "start" : e;
}
function ft(e) {
	switch (e) {
		case "top": return "bottom";
		case "bottom": return "top";
		case "left": return "right";
		case "right": return "left";
		default: return e;
	}
}
var pt = {
	left: N.withChevronOnLeft,
	right: N.withChevronOnRight,
	top: N.withChevronAtTop,
	bottom: N.withChevronAtBottom
}, mt = {
	start: N.startAlignment,
	middle: N.middleAlignment,
	end: N.endAlignment
};
function ht(e, t, n, r) {
	let i = e.left + window.scrollX, a = i + e.width / 2, o = e.top + e.height / 2 + window.scrollY, s = {
		position: "absolute",
		right: "auto"
	}, c = {
		...s,
		top: o
	}, l = {
		...s,
		left: r ? i : a,
		width: r ? e.width : void 0
	};
	switch (t) {
		case "top": return {
			...l,
			top: e.top + window.scrollY - n,
			transform: r ? "translateY(-100%)" : "translate(-50%, -100%)"
		};
		case "bottom": return {
			...l,
			top: e.bottom + window.scrollY + n,
			transform: r ? void 0 : "translateX(-50%)"
		};
		case "left": return {
			...c,
			left: i - n,
			transform: "translate(-100%, -50%)"
		};
		case "right": return {
			...c,
			left: e.right + window.scrollX + n,
			transform: "translateY(-50%)"
		};
		default: return s;
	}
}
var gt = ({ children: e, visible: t, direction: n = "bottom", alignment: r = "end", className: i, ariaHidden: o, closeLabel: s, withOuterClick: c = !0, showCloseButton: d = !0, onCloseClick: f, viewVariant: p, anchorRef: m, inheritWidth: h = !0, mainOffset: g = 10, ..._ }) => {
	let [v, y] = u(t), b = l(null), [ee, x] = u({}), S = ft(n), T = dt(r);
	if (a(() => {
		!m?.current || !t || x(ht(m.current.getBoundingClientRect(), n, g, h));
	}, [
		m,
		t,
		n,
		h,
		g
	]), ct(b, () => {
		y(!1), f?.();
	}, c && v), !v || !t) return null;
	let E = /* @__PURE__ */ w("div", {
		ref: b,
		className: M(i, N.root, pt[S], mt[T], p === "secondary" && N.secondary, m && N.portal),
		style: m ? ee : void 0,
		"aria-hidden": o,
		..._,
		children: [
			/* @__PURE__ */ C(ut, { className: N.tail }),
			/* @__PURE__ */ C("span", {
				"data-testid": P.Text,
				className: N.text,
				children: e
			}),
			d && /* @__PURE__ */ C("button", {
				"data-testid": P.CloseButton,
				onClick: () => {
					f?.(), y(!1);
				},
				type: "button",
				className: N.closeButton,
				"aria-label": s,
				children: /* @__PURE__ */ C(lt, {})
			})
		]
	});
	return m ? te(E, document.body) : E;
}, F = {
	ae: "+000 (00) 000 0000",
	ae_zero: "+000 (0) 00 000 0000",
	bh: "+000 0000 0000",
	eg: "+00 (000) 000 0000",
	jo: "+000 (0) 0000 0000",
	kw: "+000 0000 0000",
	om: "+000 (00) 000000",
	qa: "+000 0000 0000",
	sa_without_zero: "+000 (00) 000 0000",
	sa_with_zero: "+000 (000) 000 0000",
	universal: "+000 000 000 000"
}, _t = [
	{
		mask: F.eg,
		startsWith: "20"
	},
	{
		mask: F.bh,
		startsWith: "973"
	},
	{
		mask: F.jo,
		startsWith: "962"
	},
	{
		mask: F.kw,
		startsWith: "965"
	},
	{
		mask: F.sa_with_zero,
		startsWith: "9660"
	},
	{
		mask: F.sa_without_zero,
		startsWith: "966"
	},
	{
		mask: F.om,
		startsWith: "968"
	},
	{
		mask: F.ae_zero,
		startsWith: "9710"
	},
	{
		mask: F.ae,
		startsWith: "971"
	},
	{
		mask: F.qa,
		startsWith: "974"
	},
	{
		mask: F.universal,
		startsWith: ""
	}
], vt = {
	ae: "971",
	bh: "973",
	eg: "20",
	jo: "962",
	kw: "965",
	om: "968",
	qa: "974",
	sa: "966"
}, I = (e, t) => {
	let n = L(e);
	if (n === "") {
		if (t) {
			let e = vt[t.toLowerCase()];
			if (e) {
				let t = _t.find(({ startsWith: t }) => e.startsWith(t));
				if (t) {
					let e = 15 - L(t.mask).length;
					return {
						mask: t.mask + Array(Math.max(e, 0)).fill("0").join(""),
						placeholder: t.mask
					};
				}
			}
		}
		return {
			mask: F.universal,
			placeholder: F.universal
		};
	}
	let r = _t.find(({ startsWith: e }) => n.startsWith(e));
	if (!r) return {
		mask: F.universal,
		placeholder: F.universal
	};
	let i = 15 - L(r.mask).length;
	return {
		mask: r.mask + Array(Math.max(i, 0)).fill("0").join(""),
		placeholder: r.mask
	};
}, yt = (e, t) => {
	let n = L(e), r = "", i = 0;
	for (let e = 0; e < t.length && i < n.length; e++) t[e] === "0" ? (r += n[i], i += 1) : r += t[e];
	return r;
}, L = (e) => e.replace(/[^0-9]+/g, ""), bt = (e) => {
	let t = L(e);
	return t ? t.startsWith("971") ? "ae" : t.startsWith("973") ? "bh" : t.startsWith("20") ? "eg" : t.startsWith("962") ? "jo" : t.startsWith("965") ? "kw" : t.startsWith("968") ? "om" : t.startsWith("974") ? "qa" : t.startsWith("966") ? "sa" : "" : "";
}, xt = (e) => vt[e.toLowerCase()] || "", St = (e) => {
	let { phone: t, getCurrentIso2: n, handleChange: r, handleClear: i } = d(() => {
		let t = x(""), n = "", r = !1;
		if (e) {
			let i = xt(e);
			if (i) {
				let a = I(i, e);
				n = e, t.set(yt(i, a.mask)), r = !0;
			}
		}
		let i = () => t.get() ? n || "" : r ? "" : e || "";
		return {
			phone: t.seal(),
			internalIso2: n,
			isInitialized: r,
			getCurrentIso2: i,
			handleChange: (e) => {
				let a = L(e.target.value);
				if (a.length <= 15) {
					let e = bt(a), o = i(), s = yt(a, I(a, e || o).mask);
					t.set(s), s ? (n = e || "", r = !0) : n = "";
				}
			},
			handleClear: () => {
				t.set(""), n = "";
			}
		};
	});
	return {
		phone: g(t),
		iso2: n(),
		handleChange: r,
		handleClear: i
	};
}, R = {
	root: "PhoneInput_root__89meg",
	field: "PhoneInput_field__acN1k",
	flagButton: "PhoneInput_flagButton__m1vck",
	inputWrapper: "PhoneInput_inputWrapper__oH754",
	mask: "PhoneInput_mask__qj-Hw",
	maskVisible: "PhoneInput_maskVisible__yUTsv",
	input: "PhoneInput_input__uOHl-",
	clearButton: "PhoneInput_clearButton__j7qgI"
}, z = {
	flagContainer: "CountryFlag_flagContainer__wHmVI",
	flagEmoji: "CountryFlag_flagEmoji__noZE4",
	flagGlobe: "CountryFlag_flagGlobe__C1WqR"
}, Ct = (e) => {
	let t = e.toUpperCase().split("").map((e) => 127397 + e.charCodeAt(0));
	return String.fromCodePoint(...t);
}, wt = ({ iso2: e }) => {
	if (!e) return /* @__PURE__ */ C("div", {
		className: z.flagContainer,
		children: /* @__PURE__ */ C("span", { className: z.flagGlobe })
	});
	let t = Ct(e);
	return /* @__PURE__ */ C("div", {
		className: z.flagContainer,
		children: /* @__PURE__ */ C("span", {
			className: z.flagEmoji,
			children: t
		})
	});
}, Tt = r(({ iso2: e, closeIcon: t }, n) => {
	let r = l(null), { phone: i, iso2: a, handleChange: s, handleClear: c } = St(e), [d, f] = u(!1);
	o(n, () => ({ getValue: () => i }));
	let p = I(i, a), m = i.length >= p.placeholder.length, h = i && (d || m);
	return /* @__PURE__ */ C("div", {
		className: R.root,
		children: /* @__PURE__ */ w("label", {
			className: M(R.field, (i || a) && R.fieldHasValue),
			children: [
				/* @__PURE__ */ C("div", {
					className: R.flagButton,
					children: /* @__PURE__ */ C(wt, { iso2: a })
				}),
				/* @__PURE__ */ w("div", {
					className: R.inputWrapper,
					children: [/* @__PURE__ */ w("div", {
						className: R.mask,
						"aria-hidden": "true",
						children: [i, /* @__PURE__ */ C("span", {
							className: R.maskVisible,
							children: p.placeholder.slice(i.length)
						})]
					}), /* @__PURE__ */ C("input", {
						ref: r,
						type: "tel",
						inputMode: "tel",
						className: R.input,
						value: i,
						onChange: s,
						onFocus: () => f(!0),
						onBlur: () => f(!1),
						"data-testid": "phone-input"
					})]
				}),
				h && /* @__PURE__ */ C("div", {
					className: R.clearButton,
					children: t && t(c)
				})
			]
		})
	});
}), Et = ({ className: e }) => {
	let t = `2023\u2013${(/* @__PURE__ */ new Date()).getFullYear()}`;
	return /* @__PURE__ */ w("span", {
		className: e,
		"data-tid": "Copyright",
		children: [
			/* @__PURE__ */ C("bdo", {
				dir: "ltr",
				children: "©"
			}),
			"\xA0",
			/* @__PURE__ */ C("bdo", {
				dir: "ltr",
				children: t
			}),
			"\xA0",
			/* @__PURE__ */ C("bdo", {
				dir: "ltr",
				children: "Funtech Loyalty Card Services LLC"
			}),
			/* @__PURE__ */ C("bdo", {
				dir: "ltr",
				children: ", "
			}),
			/* @__PURE__ */ C("bdo", {
				dir: "ltr",
				children: "18+"
			})
		]
	});
}, B = {
	root: "FooterComponent_root__m7_vX",
	touch: "FooterComponent_touch__TncOD",
	divider: "FooterComponent_divider__8ZnY6",
	sections: "FooterComponent_sections__2Vd-H",
	sectionTitle: "FooterComponent_sectionTitle__dq8v-",
	linksList: "FooterComponent_linksList__BoNKe",
	link: "FooterComponent_link__wv6do",
	socialLinks: "FooterComponent_socialLinks__omi_w",
	socialLink: "FooterComponent_socialLink__m3TZ2",
	copyright: "FooterComponent_copyright__QB02Y",
	emptySpace: "FooterComponent_emptySpace__NbZAN",
	section: "FooterComponent_section__wsj42",
	copyrightDivider: "FooterComponent_copyrightDivider__GnPb_"
}, Dt = ({ sections: e, socialLinks: t, RouterLink: n, isTouch: r, i18nGeoWidgetEnabled: i, i18nGeoWidgetBrand: a = "yango" }) => /* @__PURE__ */ w("footer", {
	className: M(B.root, { [B.touch]: r }),
	"data-tid": "FooterComponent",
	children: [
		/* @__PURE__ */ C("div", { className: B.divider }),
		/* @__PURE__ */ w("div", {
			className: B.sections,
			children: [e.map((e) => /* @__PURE__ */ w("div", {
				className: B.section,
				children: [/* @__PURE__ */ C("h3", {
					className: B.sectionTitle,
					children: e.title
				}), /* @__PURE__ */ C("ul", {
					className: B.linksList,
					children: e.links.map((e) => /* @__PURE__ */ C("li", { children: "location" in e ? /* @__PURE__ */ C(n, {
						to: e.location,
						className: B.link,
						children: e.text
					}) : /* @__PURE__ */ C("a", {
						href: e.href,
						className: B.link,
						target: "_blank",
						rel: "noreferrer",
						children: e.text
					}) }, e.text))
				})]
			}, e.title)), /* @__PURE__ */ C("div", {
				className: B.socialLinks,
				children: t.map(({ link: e, renderIcon: t, label: n }) => /* @__PURE__ */ C("a", {
					href: e,
					className: B.socialLink,
					target: "_blank",
					rel: "noreferrer",
					"aria-label": n,
					children: t()
				}, e))
			})]
		}),
		/* @__PURE__ */ C("div", { className: B.copyrightDivider }),
		/* @__PURE__ */ C(ne, {
			enabled: i,
			brand: a,
			environment: "production",
			lang: "en",
			theme: "dark",
			children: /* @__PURE__ */ C(Et, { className: B.copyright })
		}),
		r && /* @__PURE__ */ C("div", { className: B.emptySpace })
	]
}), V = b("remoteConfig");
function Ot(e) {
	let t = y(e);
	return {
		get flags() {
			return t;
		},
		ref: () => V,
		hydrate(e) {
			t = y(e);
		},
		toJSON: () => t.toJSON()
	};
}
//#endregion
//#region src/hooks/useRemoteConfig.ts
function kt(e) {
	let t = v(V);
	return c(() => e ? e.apply(t.flags) : t, [t, e]);
}
//#endregion
//#region src/lib/requestId.ts
function At(e, t) {
	if (e == null) throw Error(`${t} is not initialized`);
}
var jt = b("requestIdManager");
function Mt(e) {
	let t, n = e?.traceparent || "";
	return typeof window > "u" && (t = ie(ae(e?.requestId), { parser: oe })), {
		get requestId() {
			return At(t, "requestId"), t;
		},
		get traceparent() {
			return n;
		},
		ref() {
			return jt;
		},
		hydrate(e) {
			t = ie(e.requestId, { parser: re }), n = e.traceparent;
		},
		toJSON() {
			return {
				requestId: this.requestId.root,
				traceparent: n
			};
		}
	};
}
//#endregion
//#region src/components/Picture/Picture.tsx
var Nt = ({ sources: e, src: t, srcSet: n, alt: r, className: i, width: a, height: o, loading: s, decoding: c, id: l, title: u, role: d, sizes: f, onError: p, onLoad: m, "data-tid": h }) => {
	let g = /* @__PURE__ */ C("img", {
		id: l,
		"data-tid": h,
		className: i,
		src: t,
		srcSet: n,
		alt: r,
		role: d,
		width: a,
		height: o,
		loading: s,
		decoding: c,
		title: u,
		sizes: f,
		onLoad: m,
		onError: p
	});
	return e && e.length > 0 ? /* @__PURE__ */ w("picture", { children: [e.map(({ srcSet: e, media: t, type: n, sizes: r }, i) => /* @__PURE__ */ C("source", {
		srcSet: e,
		media: t,
		type: n,
		sizes: r
	}, `${e || "source"}-${t || i}`)), g] }) : g;
}, Pt = "(max-width: 599px)", Ft = "(min-width: 600px)";
function It(e) {
	return e && /\/orig$/.test(e) ? e.replace("/orig", "").replace(/^.*?:\/\//, "//") : e;
}
var Lt = (e, t) => Object.entries(t).map(([t, n]) => `${e}/${n} ${t}`).join(", ");
function H(e, t) {
	return t ? `${e}/${t}` : e;
}
var Rt = (e) => e?.map(({ media: e, width: t }) => e ? `${e} ${t}` : t).join(", "), zt = (e, t) => {
	if (!(!e || t == null)) return typeof t == "string" ? H(e, t) : Lt(e, t);
}, Bt = (e) => {
	let t = {
		...e,
		...e.mobile && !e.mobile.media ? { mobile: {
			...e.mobile,
			media: Pt
		} } : {},
		...e.tablet && !e.tablet.media ? { tablet: {
			...e.tablet,
			media: Ft
		} } : {}
	};
	return (e) => {
		let n = Object.fromEntries(Object.entries(e).map(([e, t]) => [e, t && It(t)])), r = [], i = [], a = t.fallback, { fallbackUrl: o } = n, s = {
			src: o && a ? H(o, a.src) : void 0,
			srcSet: o && a ? zt(o, a.srcSet) : void 0,
			sizes: a ? Rt(a.sizes) : void 0
		};
		return Object.keys(t).forEach((e) => {
			let a = t[e], o = n[`${e}Url`];
			if (a && o && typeof a.srcSet == "object" && e !== "fallback") {
				let e = a.srcSet ? Lt(o, a.srcSet) : void 0, t = a.href ? H(o, a.href) : void 0;
				r.push({
					media: a.media,
					type: a.type,
					srcSet: e,
					sizes: Rt(a.sizes)
				}), i.push({
					media: a.media,
					href: t,
					imageSrcSet: e
				});
			}
		}), {
			sources: r,
			img: s,
			preloadLinks: i
		};
	};
};
//#endregion
//#region src/lib/featureFlags.ts
function Vt(e) {
	let t = {}, n = {};
	return e.forEach(({ source: e, values: r }) => {
		Object.entries(r ?? {}).forEach(([r, i]) => {
			t[r] = i, n[r] = e;
		});
	}), {
		flags: t,
		sources: n
	};
}
var U = b("featureFlags");
function Ht(e) {
	let t = y(), n = {}, r = [], i = {}, a = [];
	e && o(e);
	function o(e) {
		if (Array.isArray(e.flags)) {
			let r = Vt(e.flags);
			t = y(r.flags), n = r.sources;
		} else t = y(e.flags), n = e.sources ?? {};
		r = e.testIds || [], i = e.grouped || {}, a = e.rumSlots || [];
	}
	return {
		get flags() {
			return t;
		},
		get sources() {
			return n;
		},
		get testIds() {
			return r;
		},
		get grouped() {
			return i;
		},
		get rumSlots() {
			return a;
		},
		ref: () => U,
		hydrate: o,
		toJSON() {
			return {
				flags: t.toJSON(),
				sources: n,
				testIds: r,
				grouped: i,
				rumSlots: a
			};
		}
	};
}
//#endregion
//#region src/hooks/useFeatureFlags.ts
function Ut(e) {
	let t = v(U);
	return c(() => e ? {
		...t,
		flags: e.apply(t.flags)
	} : t, [t, e]);
}
//#endregion
//#region src/lib/featureFlagsOverride.ts
var Wt = "ff_";
function Gt(e, t = Wt) {
	return [...e.entries()].reduce((e, [n, r]) => {
		if (!n.startsWith(t) || n.length === t.length) return e;
		let i = n.slice(t.length);
		try {
			e[i] = JSON.parse(r);
		} catch {
			e[i] = r;
		}
		return e;
	}, {});
}
//#endregion
//#region src/lib/schema.ts
var W = class e extends Error {
	name = "SchemeError";
	parseStack;
	constructor(t) {
		super(t.message), this.parseStack = [t.message], t.error instanceof e && this.parseStack.push(...t.error.parseStack);
	}
};
function Kt(e) {
	return "optional" in e;
}
function G(e) {
	function t(t) {
		return { parse(n) {
			return n === void 0 ? t : e(n);
		} };
	}
	return {
		parse: e,
		optional: t
	};
}
function qt(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
var Jt = G((e) => {
	if (e === "true" || e === "1" || e === !0) return !0;
	if (e === "false" || e === "0" || e === !1) return !1;
	throw new W({ message: "Value is not a valid boolean" });
}), Yt = G((e) => {
	if (typeof e == "string") return e;
	throw new W({ message: "Value is not a string" });
}), Xt = G((e) => {
	let t = typeof e == "string" && e.trim() !== "" ? Number(e) : e;
	if (typeof t == "number" && !Number.isNaN(t) && Number.isFinite(t)) return t;
	throw new W({ message: "Value is not a valid number" });
});
function Zt(e) {
	let t = new Set(e);
	return G((e) => {
		if (t.has(e)) return e;
		throw new W({ message: "Value is not a valid enum value" });
	});
}
function Qt(e) {
	return G((t) => {
		if (!Array.isArray(t)) throw new W({ message: "Value is not an array" });
		return t.map((t) => e.parse(t));
	});
}
function $t(e) {
	return G((t) => {
		if (!qt(t)) throw new W({ message: "Value is not an object" });
		return Object.fromEntries(Object.entries(t).map(([t, n]) => [t, e.parse(n)]));
	});
}
function en(e) {
	return G((t) => {
		if (!qt(t)) throw new W({ message: "Value is not an object" });
		let n = Object.keys(e).map((n) => {
			let r = e[n];
			try {
				return [n, r.parse(t[n])];
			} catch (e) {
				throw new W({
					message: `Cannot parse object key="${n}"`,
					error: e
				});
			}
		});
		return Object.fromEntries(n);
	});
}
var tn = {
	boolean: Jt,
	string: Yt,
	number: Xt,
	enum: Zt,
	arrayOf: Qt,
	mapOf: $t,
	create: en
};
//#endregion
//#region src/lib/flagsScheme.ts
function nn(e) {
	return { apply(t) {
		return { get(n) {
			let r = e[n], i = t.get(n);
			try {
				return r.parse(i);
			} catch (e) {
				let t = String(n), a = e instanceof Error ? e.message : String(e);
				if (Kt(r)) throw Error(`Scheme for "${t}" failed: ${a}${i === void 0 ? " — declare a default via .optional()" : ""}`);
				return r.parse(void 0);
			}
		} };
	} };
}
//#endregion
//#region src/lib/script.ts
var rn = (e, t = document.body, n = {}, r = void 0) => new Promise((i, a) => {
	let o = document.createElement("script");
	o.type = "text/javascript", o.src = e, o.onload = i, o.onerror = a, Object.keys(n).forEach((e) => {
		let t = n[e];
		typeof t == "string" && o.setAttribute(e, t), typeof t == "boolean" && o.setAttribute(e, "");
	}), r ? t.insertAdjacentElement(r, o) : t.appendChild(o);
}), an = {}, on = async (e, ...t) => {
	if (e in an) {
		let t = an[e];
		if (t) return Promise.resolve(t);
	}
	let n = await rn(e, ...t);
	return an[e] = n, n;
};
async function sn(e, t, n) {
	let { to: r = document.body, params: i = {}, errorMessage: a = `Script "${e}" load error` } = t || {}, o;
	try {
		o = await rn(e, r, i);
	} catch (e) {
		throw e instanceof Error && n.error({ error: e }, a), e;
	}
	return o;
}
//#endregion
//#region src/lib/gtm.ts
var cn = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content"
], ln = [
	"gclid",
	"fbclid",
	"yclid",
	"ttclid",
	"rb_clickid"
], un = [...cn, ...ln], K = "dataLayer", dn = globalThis, fn = b("gtmService");
function pn({ logger: e, trackedQueryParamsStore: t, nonce: n }) {
	let r, i, a = !1, o, s = n ?? "", c;
	async function l(t) {
		if (!t.containerId) {
			e.error("You must specify `container` query parameter for GTM!");
			return;
		}
		if (a) return;
		dn[K] || (dn[K] = []), c = t.source, a = !0, i = t.containerId, r = t.userId, o = dn[K], o.push({ data_layer_nonce: s }), o.push({
			"gtm.start": (/* @__PURE__ */ new Date()).getTime(),
			event: "gtm.js"
		});
		let n = new URL("https://www.googletagmanager.com/gtm.js");
		n.searchParams.set("id", i), n.searchParams.set("l", K);
		try {
			await on(n.toString(), document.head, {
				async: !0,
				nonce: s
			}, "afterbegin");
		} catch (t) {
			e.error({ error: t }, "GTM load failed");
		}
		o.push(u());
	}
	function u() {
		return {
			source: c,
			container: i,
			...t?.getParams(un)
		};
	}
	function d(e) {
		if (!r || !o) return;
		let t = {
			source: c,
			container: i,
			...u(),
			...e,
			userId: r
		};
		o.push(t);
	}
	return {
		initialize: l,
		send: d,
		ref: () => fn,
		hydrate: (e) => {
			s = e;
		},
		toJSON: () => s
	};
}
//#endregion
//#region src/hooks/useGtmService.ts
function mn() {
	return f(fn);
}
//#endregion
//#region src/lib/metrika/api.ts
var hn = "yandex_metrika_callbacks2", gn = 2e3, _n = 3, vn = 1e3;
function yn({ initialParams: e, scriptSrc: t, logger: n }) {
	let r = null, i = [], a = () => window.Ya?.Metrika2, o = () => new Promise((e, n) => {
		let r = a();
		if (r) {
			e(r);
			return;
		}
		let i = setTimeout(n, gn);
		Array.isArray(window[hn]) || (window[hn] = []), window[hn].push(() => {
			clearTimeout(i);
			let t = a();
			t ? e(t) : n();
		}), on(t, document.body, { async: !0 }).catch(() => {
			clearTimeout(i), n();
		});
	}), s = async (e = 1) => {
		try {
			return await o();
		} catch (r) {
			if (e >= _n) {
				n?.warn({
					error: r,
					scriptSrc: t,
					attempt: e
				}, "Metrika tag load failed");
				return;
			}
			return await new Promise((e) => {
				setTimeout(e, vn);
			}), s(e + 1);
		}
	}, c = (e) => {
		if (r) try {
			switch (e.type) {
				case "params":
					r.params(...e.payload);
					break;
				case "reachGoal":
					r.reachGoal(...e.payload);
					break;
				default: break;
			}
		} catch (e) {
			n?.error({ error: e }, "Metrika event handling failed");
		}
	};
	return (async () => {
		let t = await s();
		t && (r = new t(e), i.forEach((e) => {
			c(e);
		}), i = []);
	})(), { emit: (e) => {
		r ? c(e) : i.push(e);
	} };
}
//#endregion
//#region src/lib/metrika/createMetrikaService.ts
var bn = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content"
], xn = b("metrikaService"), Sn = (e) => {
	let t = new URL(window.location.href), n = e?.getParams(bn) ?? {};
	return Object.entries(n).forEach(([e, n]) => {
		t.searchParams.set(e, String(n));
	}), t.toString();
};
function Cn({ counter: e, scriptSrc: t, logger: n, trackedQueryParamsStore: r }) {
	let i = null;
	return typeof window < "u" && (i = yn({
		initialParams: {
			...e,
			url: Sn(r)
		},
		scriptSrc: t,
		logger: n
	})), {
		trackEvent: (e, t) => i?.emit({
			type: "params",
			payload: [{ [e]: t }]
		}),
		reachGoal: (e, t) => i?.emit({
			type: "reachGoal",
			payload: [e, t]
		}),
		ref: () => xn
	};
}
//#endregion
//#region src/hooks/useMetrikaService.ts
function wn() {
	return f(xn);
}
//#endregion
//#region src/lib/queryParams.ts
var Tn = "query_params", En = () => typeof window > "u" ? {} : Object.fromEntries(new URLSearchParams(window.location.search)), Dn = (e, t) => t.length === 0 ? e : t.reduce((t, n) => {
	let r = e[n];
	return r && (t[n] = r), t;
}, {}), On = b("queryParamsStore");
function kn(e) {
	let { storage: t, storageKey: n = Tn } = e, r = t.get(n) ?? {};
	function i(e) {
		Object.keys(e).length !== 0 && t.set(n, e) && (r = e);
	}
	function a() {
		return Object.keys(r).length === 0 && i(En()), r;
	}
	function o(e) {
		return Dn(r, e);
	}
	return {
		getParams: o,
		initialize: a,
		ref: () => On
	};
}
//#endregion
//#region src/hooks/useQueryParamsStore.ts
function An() {
	return f(On);
}
//#endregion
//#region src/lib/lazyFactory.ts
function q(e) {
	let t, n = !1;
	return (...r) => (n ||= (t = e(...r), !0), t);
}
//#endregion
//#region src/lib/payments/offers.ts
var jn = (e = []) => e.reduce((e, t) => {
	let n = Number(t);
	return Number.isInteger(n) && e.push(n), e;
}, []), Mn = (e = {}) => Object.keys(e).filter((t) => !!e[t]);
function J(e, t) {
	let n = e.analyticData?.batchId, r = e.analyticData?.positionId, i = e.catalogCompositeOffer?.tariffOffer?.name, a = e.catalogCompositeOffer?.optionOffers?.[0]?.name;
	return {
		...e,
		eventSessionId: t,
		offerPositionsData: n ? { offersBatchId: { [n]: { offersPositionIds: [r] } } } : {},
		billingProductIds: `${i || "NONE"}, ${a || "NONE"}`
	};
}
var Nn = async (e, t) => {
	let { page: n, places: r, extraParams: i } = t, { sessionId: a, result: o } = await e.getBestOffers(n, r, i);
	return r.map((e) => {
		let t = o[e];
		return !t || t.target === null ? null : J(t, a ?? "");
	}).filter((e) => e !== null);
}, Pn = async (e, t) => {
	let { page: n, places: r, extraParams: i } = t, { sessionId: a, result: o } = await e.getCarouselOffers(n, r, i), s = {};
	return Object.keys(o).forEach((e) => {
		s[e] = (o[e] ?? []).map((e) => J(e, a ?? ""));
	}), s;
}, Fn = async (e, t) => {
	let { target: n, features: r, extraParams: i } = t, a = {
		target: n,
		features: r
	}, { sessionId: o, result: s } = await e.getBestOffers([a], i), c = s.get(a) ?? null;
	return c ? [J(c, o ?? "")] : [];
}, In = async (e, t) => {
	let { featureTargets: n, extraParams: r } = t, i = n.map(({ target: e, billingFeatureName: t }) => ({
		target: e,
		features: [t]
	})), { sessionId: a, result: o } = await e.getBestOffers(i, r);
	return i.map((e) => {
		let t = o.get(e) ?? null;
		return t ? J(t, a ?? "") : null;
	}).filter((e) => e !== null);
};
function Ln(e, { featureFlags: t, logger: n }) {
	let r = e(), i = {
		expTestIds: jn(t.testIds),
		expFlags: Mn(t.flags.toJSON())
	};
	async function a(e) {
		try {
			return "featureTargets" in e ? await In(r, {
				featureTargets: e.featureTargets,
				extraParams: {
					...i,
					...e.extraParams
				}
			}) : "target" in e ? await Fn(r, {
				target: e.target,
				features: e.features,
				extraParams: {
					...i,
					...e.extraParams
				}
			}) : await Nn(r, {
				places: e.places,
				page: e.page,
				extraParams: {
					...i,
					...e.extraParams
				}
			});
		} catch (t) {
			throw t instanceof Error && n.error({
				error: t,
				params: e
			}, "Failed to get offers"), t;
		}
	}
	async function o(e) {
		try {
			let t = {
				...i,
				...e.extraParams
			};
			return await Pn(r, {
				places: e.places,
				page: e.page,
				extraParams: t
			});
		} catch (t) {
			throw t instanceof Error && n.error({
				error: t,
				params: e
			}, "Failed to get offers carousel"), t;
		}
	}
	return {
		getOffers: a,
		getOffersCarousel: o
	};
}
//#endregion
//#region src/lib/disposable.ts
function Rn() {
	let e = /* @__PURE__ */ new Set(), t = !1;
	return {
		get disposed() {
			return t;
		},
		add(n) {
			return t ? (n(), () => {}) : (e.add(n), () => {
				e.delete(n);
			});
		},
		dispose() {
			if (t) return;
			t = !0;
			let n = Array.from(e).reverse();
			e.clear();
			let r = [];
			if (n.forEach((e) => {
				try {
					e();
				} catch (e) {
					r.push(e);
				}
			}), r.length === 1) throw r[0];
			if (r.length > 1) {
				let e = /* @__PURE__ */ Error("Multiple disposal errors");
				throw Object.assign(e, { errors: r }), e;
			}
		}
	};
}
//#endregion
//#region src/lib/payments/widget.ts
function zn(e, t, n, r) {
	return new le(e, {
		eventSessionId: t,
		offersBatchId: n,
		offersPositionIds: [r],
		theme: e.options.theme
	});
}
var Bn = (e, { onClose: t, onPurchaseSuccess: n, onPurchaseError: r, onError: i, onLoad: a, onScenarioChange: o, onSuccessClose: s, onNeedAuth: c }) => {
	let l = !1;
	return e.on("*", (e) => {
		switch (e.name) {
			case "close":
				t?.(), l &&= (s?.(), !1);
				break;
			case "purchase-success":
				l = !0, n?.(e);
				break;
			case "purchase-error":
				r?.(e);
				break;
			case "error":
				i?.(e);
				break;
			case "page-mount":
				o?.(e.data.scenario);
				break;
			case "load":
				a?.();
				break;
			case "need-auth":
				c?.();
				break;
			default: break;
		}
	});
};
function Vn(e, t) {
	e.setAttribute("aria-hidden", String(t));
}
function Hn(e, t) {
	e.setAttribute("data-scenario", t);
}
function Un(e, t, n) {
	let { eventSessionId: r, batchId: i, positionId: a } = n, o = zn(e, r, i, a), s;
	return {
		destroy() {
			s?.(), o.destroy(), o.unmount();
		},
		async mount(e, n, r) {
			try {
				return s = Bn(o, {
					...r,
					onLoad: () => {
						Vn(n, !1), r.onLoad?.();
					},
					onClose: () => {
						Vn(n, !0), r.onClose?.();
					}
				}), o.setOnScenarioChange((e) => {
					Hn(n, e), r.onScenarioChange?.(e);
				}), await o.mount({
					offer: e,
					targetNode: n
				});
			} catch (e) {
				throw e instanceof Error && t.error({ error: e }, "Couldn't open payment widget"), s?.(), e;
			}
		}
	};
}
//#endregion
//#region src/lib/payments/paymentPlace.ts
function Wn(e) {
	return "places" in e;
}
var Gn = ({ getOffersClient: e, getPwTools: t, getPaymentAnalytics: n, getWidgetTargetNode: r, modalController: i, logger: a }) => (o) => {
	let s = n(), c = "page" in o ? o.page : "", l = (e) => ({
		eventSessionId: e.eventSessionId,
		positionId: e.analyticData.positionId,
		position: Number(e.analyticData.positionId),
		batchId: e.analyticData.batchId,
		place: e.place ?? "",
		url: window.location.href,
		page: c
	});
	return {
		analytics: {
			async offerShowed(e) {
				s.sendOfferShow(l(e));
			},
			async offerClicked(e) {
				s.sendOfferClick(l(e));
			}
		},
		async getOffers() {
			let t = await e().getOffers(o);
			return t.length && s.sendOffersLoadResult(t), t;
		},
		async getCarouselOffers() {
			let t = e();
			if (!Wn(o)) return a.error("Current payment place params are not valid for carousel request"), {};
			let n = await t.getOffersCarousel(o);
			return Object.keys(n).forEach((e) => {
				let t = n?.[e];
				t && s.sendOffersLoadResult(t);
			}), n;
		},
		async checkout(e, n, o) {
			let s = r();
			if (!s) {
				a.error("No target node for payment widget found");
				return;
			}
			let c = Un(t(), a, {
				eventSessionId: e.eventSessionId,
				batchId: e.analyticData.batchId,
				positionId: e.analyticData.positionId
			}), l = Rn();
			if (l.add(() => c.destroy()), l.add(i.scenario.listen(() => {
				i.scenario.get() === null && l.dispose();
			})), o) {
				let e = () => l.dispose();
				o.addEventListener("abort", e), l.add(() => o.removeEventListener("abort", e));
			}
			let u = (e) => {
				l.dispose(), i.close(), e?.();
			}, d = {
				...n,
				onClose: () => u(n.onClose),
				onNeedAuth: () => u(n.onNeedAuth),
				onScenarioChange: (e) => {
					l.disposed || (i.open(e), n.onScenarioChange?.(e));
				}
			};
			try {
				await c.mount(e, s, d);
			} catch (e) {
				throw l.dispose(), e;
			}
		}
	};
};
//#endregion
//#region src/lib/payments/analytics.ts
function Kn(e) {
	return {
		content_group_uuid: e.contentId,
		promotion_id: e.promotionId
	};
}
var qn = (e, t) => {
	let { featureFlags: n, channel: r, counterId: i, service: a, logger: o } = t, s = e().plusPaymentEvents;
	return {
		sendOfferClick: async (e) => {
			try {
				e.customParams && s.updateCustomParameters(Kn(e.customParams)), s.offerClick({
					session_id: e.eventSessionId,
					offers_position_id: e.positionId,
					offers_batch_id: e.batchId,
					page: e.page,
					place: e.place,
					from: "",
					position: e.position,
					url: e.url
				});
			} catch (e) {
				o.error({ error: e }, "sendOfferClick error");
			}
		},
		sendOfferShow: async (e) => {
			try {
				e.customParams && s.updateCustomParameters(Kn(e.customParams)), s.offerShow({
					session_id: e.eventSessionId,
					offers_position_id: e.positionId,
					offers_batch_id: e.batchId,
					position: e.position,
					page: e.page,
					place: e.place,
					from: "",
					url: e.url
				});
			} catch (e) {
				o.error({ error: e }, "sendOfferShow error");
			}
		},
		sendOffersLoadResult: async (e) => {
			try {
				if (!e[0]) return;
				let t = jn(n.testIds).join(","), { eventSessionId: o } = e[0];
				s.frontSessionStart({
					service: a,
					service_channel: r,
					session_id: o,
					external_test_ids: t,
					external_triggered_test_ids: t
				}, String(i)), e.forEach((e) => {
					s.loadOffersResulted({
						session_id: o,
						target: e.target,
						resulted_offer_position_ids: [e.analyticData.positionId],
						offers_batch_id: e.analyticData.batchId
					});
				});
			} catch (e) {
				o.error({ error: e }, "sendOffersLoadResult error");
			}
		}
	};
};
//#endregion
//#region src/lib/payments/modal.ts
function Jn() {
	let e = x(null);
	return {
		open: (t) => {
			e.set(t);
		},
		close: () => {
			e.set(null);
		},
		scenario: e.seal()
	};
}
//#endregion
//#region src/lib/payments/index.ts
var Yn = b("payments"), Xn = "default", Zn = {
	web: {
		mode: "iframe",
		platform: "web",
		acqPlatform: "Web"
	},
	touch: {
		mode: "iframe",
		platform: "web",
		acqPlatform: "WebTouch"
	},
	desktop: {
		mode: "iframe",
		platform: "web",
		acqPlatform: "WebDesktop"
	}
}, Qn = (e) => {
	let { sessionParams: t, serviceParams: n, lang: r, puid: i } = e, a = Zn[n.platform], o = {
		mode: a.mode,
		platform: a.platform,
		preloadManager: !1,
		lang: r,
		brand: n.brand,
		puid: i ? String(i) : null,
		widgetServiceName: n.widgetServiceName,
		theme: n.theme,
		environment: t.environment,
		serviceSessionId: t.serviceSessionId,
		authMethod: t.authMethod ?? Xn
	};
	return ce.from(o);
};
function $n(e) {
	let { logger: t, featureFlags: n, lang: r, authManager: i, serviceParams: a, sessionParams: o, requester: s, getWidgetTargetNode: c } = e, l = q(() => Qn({
		serviceParams: a,
		sessionParams: o,
		lang: r,
		puid: i.userProfile?.puid
	})), u = q(() => new se({
		lang: r,
		puid: i.userProfile?.puid ? String(i.userProfile.puid) : null,
		brand: a.brand,
		requester: s,
		platform: Zn[a.platform].acqPlatform,
		authMethod: o.authMethod ?? Xn,
		service: a.widgetServiceName,
		environment: o.environment,
		oAuthToken: null
	})), d = q(() => Ln(u, {
		logger: t,
		featureFlags: n
	})), f = q(() => qn(l, {
		featureFlags: n,
		channel: a.channel,
		counterId: a.counterId,
		service: a.name,
		logger: e.logger
	})), p = Jn();
	return {
		modal: p,
		createPaymentPlace: Gn({
			getOffersClient: d,
			getPwTools: l,
			getPaymentAnalytics: f,
			getWidgetTargetNode: c,
			modalController: p,
			logger: t
		}),
		ref: () => Yn
	};
}
//#endregion
//#region src/lib/payments/urlOfferParams.ts
var Y = {
	autoOpen: "isOpenPw",
	target: "target",
	billingFeatureName: "billingFeatureName"
}, X = {
	autoOpen: "subscription_auto_open",
	target: "subscription_target",
	billingFeatureName: "subscription_billing_feature"
}, er = [...Object.values(Y), ...Object.values(X)], tr = (e) => {
	try {
		let t = new URLSearchParams(e || "");
		if ((t.get(Y.autoOpen) || t.get(X.autoOpen)) !== "1") return null;
		let n = t.get(Y.target) || t.get(X.target), r = t.get(Y.billingFeatureName) || t.get(X.billingFeatureName);
		return !n || !r ? null : {
			target: n,
			billingFeatureName: r
		};
	} catch {
		return null;
	}
}, nr = (e, t = window.location.href) => {
	let n = new URL(t);
	return n.searchParams.set(Y.autoOpen, "1"), n.searchParams.set(Y.target, e.target), n.searchParams.set(Y.billingFeatureName, e.billingFeatureName), n;
}, rr = (e, { defaultTarget: t } = {}) => {
	if (!e) return;
	let n = e.requestedFeatures?.[0], r = e.target || t;
	if (!(!n || !r)) try {
		return nr({
			target: r,
			billingFeatureName: n
		});
	} catch {
		return;
	}
}, ir = (e) => ee({
	key: (t) => [e, JSON.stringify(t.variables)].join(":"),
	fetch: (e) => e.fetch()
});
function ar(e, t, n) {
	let r = v(Yn), i = d(() => r.createPaymentPlace(e)), [a] = p(t({
		variables: e,
		fetch: n(i)
	}));
	return {
		offers: a,
		analytics: i.analytics,
		checkout: i.checkout
	};
}
//#endregion
//#region src/hooks/usePaymentPlace.ts
var or = ir("paymentPlace");
function sr(e, t) {
	return e.find((e) => Object.entries(t).every(([t, n]) => e[t] === n)) ?? null;
}
function cr(e) {
	let { offers: t, checkout: n, analytics: r } = ar(e, or, (e) => e.getOffers);
	return c(() => ({
		offers: t,
		checkout: n,
		analytics: r,
		selectOfferBy: (e) => t?.length ? sr(t, e) : null
	}), [
		t,
		r,
		n
	]);
}
//#endregion
//#region src/hooks/useCarouselPaymentPlace.ts
var lr = ir("carousel");
function ur(e) {
	let { offers: t, checkout: n, analytics: r } = ar(e, lr, (e) => e.getCarouselOffers);
	return c(() => ({
		offers: t,
		checkout: n,
		analytics: r,
		selectOffersByPlace: (e) => t?.[e] ?? null
	}), [
		t,
		r,
		n
	]);
}
//#endregion
//#region src/lib/payments/paymentWidgetParamsManager.ts
function dr(e) {
	return {
		get(t) {
			return e.find((e) => e.read(t) !== null)?.read(t) ?? null;
		},
		set(t) {
			e.forEach((e) => e.write(t));
		},
		clear(t) {
			e.forEach((e) => e.clear(t));
		},
		hasAutoOpenFlag(t) {
			return e.some((e) => e.hasAutoOpenFlag(t));
		}
	};
}
function fr(e) {
	return {
		read(e) {
			return tr(e.search);
		},
		write() {},
		clear(t) {
			try {
				let n = new URLSearchParams(t.search || "");
				er.forEach((e) => n.delete(e));
				let r = n.toString();
				if (r !== t.search) {
					let t = r ? new URLSearchParams(r) : void 0;
					e.navigate({
						to: e.location,
						replace: !0,
						meta: t ? { searchParams: t } : void 0
					});
				}
			} catch {}
		},
		hasAutoOpenFlag(e) {
			try {
				return new URLSearchParams(e.search || "").get(Y.autoOpen) === "1";
			} catch {
				return !1;
			}
		}
	};
}
var pr = "openedOfferParams";
function mr(e) {
	let t = () => {
		e.session.remove(pr);
	}, n = (n) => {
		try {
			let n = e.session.get(pr);
			if (!n) return null;
			let r = JSON.parse(n);
			return !r || typeof r != "object" || typeof r.target != "string" || typeof r.billingFeatureName != "string" || !r.target.trim() || !r.billingFeatureName.trim() ? (t(), null) : r;
		} catch {
			return t(), null;
		}
	};
	return {
		read: n,
		write(t) {
			try {
				let n = {
					target: String(t.target).trim(),
					billingFeatureName: String(t.billingFeatureName).trim()
				};
				e.session.set(pr, JSON.stringify(n));
			} catch {}
		},
		clear: (e) => t(),
		hasAutoOpenFlag(e) {
			return n(e) !== null;
		}
	};
}
//#endregion
//#region src/hooks/useAutoOpenPaymentWidget.ts
var hr = ({ isAuthorized: e, hasSpecificSubscription: t, isUrlSourceEnabled: n }) => {
	let r = m(), a = h(), o = ue(), l = d(() => {
		let e = mr(o);
		return dr(n ? [fr(r), e] : [e]);
	}), u = c(() => l.get({ search: a?.toString() || "" }), [l, a]), f = !!(u?.billingFeatureName && !t(u.billingFeatureName)), p = f && e, g = i(() => {
		l.clear({ search: a?.toString() || "" });
	}, [l, a]), _ = i((e) => {
		l.set(e);
	}, [l]);
	return s(() => {
		l.hasAutoOpenFlag({ search: a?.toString() || "" }) && (f || l.clear({ search: a?.toString() || "" }));
	}, [
		l,
		f,
		a
	]), {
		shouldOpenWidget: p,
		target: u?.target,
		billingFeatureName: u?.billingFeatureName,
		setParams: _,
		clearParams: g
	};
}, gr = "default";
function _r({ brand: e, environment: t, requester: n }) {
	let r = q(() => new de({
		brand: e,
		environment: t,
		authMethod: gr,
		getAuthToken: () => null,
		requester: n
	}));
	return async (e) => String(await r().assign(e ?? {})) === "SUCCESS";
}
//#endregion
//#region src/lib/dcb/createDcbManager.ts
var vr = b("dcbManager"), yr = 500, br = 10;
function xr({ brand: e, environment: t, requester: n, getIsAuthorized: r, getHasSubscription: i, logger: a }) {
	let o = _r({
		brand: e,
		environment: t,
		requester: n
	}), s = x("idle"), c = s.seal(), l = !1;
	async function u() {
		if (l || typeof window > "u" || (l = !0, !r() || i())) return;
		s.set("pending");
		let e = setTimeout(() => {
			s.get() === "pending" && s.set("screen");
		}, yr);
		try {
			if (await o({ maxAttempts: br })) {
				window.location.reload();
				return;
			}
		} catch (e) {
			a.warn({ error: e }, "DCB autolink assign failed");
		} finally {
			clearTimeout(e);
		}
		s.set("done");
	}
	return {
		phase: c,
		run: u,
		ref: () => vr
	};
}
//#endregion
//#region src/hooks/useDcbAutolink.ts
var Sr = x("idle").seal();
function Cr() {
	let e = f(vr), t = g(e?.phase ?? Sr);
	return a(() => {
		e?.run();
	}, [e]), t === "screen";
}
//#endregion
//#region src/lib/vitals/metric.duration.ts
function wr(e, t) {
	let n = /* @__PURE__ */ new Set(), r = (t) => {
		n.forEach((n) => n(e, t));
	}, i = () => {
		let e = null;
		return {
			begin() {
				e = performance.now();
			},
			end() {
				e !== null && (r(performance.now() - e), e = null);
			},
			cancel() {
				e = null;
			}
		};
	}, a;
	return {
		observe(e) {
			return n.add(e), () => n.delete(e);
		},
		measure() {
			return t?.persistent ? (a ??= i(), a) : i();
		}
	};
}
//#endregion
//#region src/lib/vitals/metric.web-vitals.ts
function Tr(e) {
	let t = /* @__PURE__ */ new Set(), n = (e, n) => {
		t.forEach((t) => t(e, n));
	}, r = /* @__PURE__ */ new Map(), i = () => {
		if (!window || !PerformanceObserver) return;
		let { fcp: t, cls: i, lcp: a, inp: o } = e;
		t && r.set("fcp", Er((e) => n(t, e))), i && console.warn("Not implemented web vitals metric CLS"), a && console.warn("Not implemented web vitals metric LCP"), o && console.warn("Not implemented web vitals metric INP");
	}, a = () => {
		r.forEach((e) => e.disconnect()), r.clear();
	};
	return {
		observe(e) {
			return t.size === 0 && i(), t.add(e), () => {
				t.delete(e), t.size === 0 && a();
			};
		},
		measure() {}
	};
}
function Er(e) {
	let t = new PerformanceObserver((n) => {
		let r = n.getEntriesByName("first-contentful-paint")[0];
		r && (t.disconnect(), e(r.startTime));
	});
	return t.observe({
		type: "paint",
		buffered: !0
	}), t;
}
//#endregion
//#region src/lib/vitals/metric.rival-route.ts
function Dr(e) {
	let t = /* @__PURE__ */ new Set(), n = (e, n, r) => {
		t.forEach((t) => t(e, n, r));
	};
	return {
		observe(e) {
			return t.add(e), () => t.delete(e);
		},
		measure(t) {
			let r = t.routingStart, i, a = (e) => {
				n(e, performance.now() - r, i);
			}, o = {}, { render: s, fetch: c, complete: l } = e;
			return (s || c || l) && (o.onChange = (e, t) => {
				r = performance.now(), i = {
					from: e,
					to: t
				};
			}), s && (o.onRender = () => a(s)), c && (o.onFetch = () => a(c)), l && (o.onComplete = () => a(l)), o;
		}
	};
}
//#endregion
//#region src/lib/vitals/manager.ts
var Z = b("vitalsManager");
function Or(e) {
	let { globals: t = [], onReport: n } = e, r = /* @__PURE__ */ new Map(), i = {
		attach(e) {
			r.has(e) || r.set(e, e.observe(n));
		},
		detach(e) {
			r.get(e)?.(), r.delete(e);
		},
		ref: () => Z
	};
	return t.forEach((e) => i.attach(e)), i;
}
//#endregion
//#region src/hooks/useVitalMetric.ts
function kr(e, ...[t]) {
	let n = f(Z), r = e.measure;
	return s(() => (n?.attach(e), () => n?.detach(e)), [n, e]), c(() => r(t), [r]);
}
//#endregion
//#region src/lib/authManager.ts
var Ar = b("authManager");
function jr(e) {
	let t = !1, n = "";
	return {
		get isAuthorized() {
			return t;
		},
		get yandexuid() {
			return n;
		},
		setIsAuthorized(e) {
			t = e;
		},
		setYandexuid(e) {
			n = e;
		},
		getLoginUrl(t) {
			let n = new URL("/auth", e.passportHost);
			return n.searchParams.set("origin", e.origin), n.searchParams.set("lang", e.lang), n.searchParams.set("retpath", t.toString()), n;
		},
		getLogoutUrl(t) {
			let r = new URL("/passport", e.passportHost);
			return r.searchParams.set("mode", "logout"), r.searchParams.set("yu", n), r.searchParams.set("retpath", t.toString()), r;
		},
		getAuthAccountUrl(t, r) {
			let i = new URL("/auth", e.passportHost);
			return i.searchParams.set("login", t), i.searchParams.set("yu", n), i.searchParams.set("origin", e.origin), i.searchParams.set("lang", e.lang), i.searchParams.set("retpath", r.toString()), i;
		},
		getChangeMultiAccountUrl(t, r) {
			let i = new URL("/passport", e.passportHost);
			return i.searchParams.set("action", "change_default"), i.searchParams.set("mode", "embeddedauth"), i.searchParams.set("uid", t), i.searchParams.set("yu", n), i.searchParams.set("origin", e.origin), i.searchParams.set("lang", e.lang), i.searchParams.set("retpath", r.toString()), i;
		},
		getAddAccountUrl(t) {
			let n = new URL("/auth", e.passportHost);
			return n.searchParams.set("mode", "add-user"), n.searchParams.set("origin", e.origin), n.searchParams.set("lang", e.lang), n.searchParams.set("retpath", t.toString()), n;
		},
		ref() {
			return Ar;
		},
		hydrate(e) {
			t = e.isAuthorized, n = e.yandexuid;
		},
		toJSON() {
			return {
				isAuthorized: t,
				yandexuid: n
			};
		}
	};
}
function Q(e, t) {
	let n = new URL("/push", e);
	return n.searchParams.set("retpath", t.toString()), n.searchParams.set("uuid", Nr()), n;
}
function Mr({ ssoHost: e, ...t }) {
	let n = jr(t);
	return {
		get isAuthorized() {
			return n.isAuthorized;
		},
		get yandexuid() {
			return n.yandexuid;
		},
		setIsAuthorized: n.setIsAuthorized,
		setYandexuid: n.setYandexuid,
		getLoginUrl(t) {
			return n.getLoginUrl(Q(e, t));
		},
		getLogoutUrl(t) {
			return n.getLogoutUrl(Q(e, t));
		},
		getAuthAccountUrl(t, r) {
			return n.getAuthAccountUrl(t, Q(e, r));
		},
		getChangeMultiAccountUrl(t, r) {
			return n.getChangeMultiAccountUrl(t, Q(e, r));
		},
		getAddAccountUrl(t) {
			return n.getAddAccountUrl(Q(e, t));
		},
		ref: n.ref,
		hydrate: n.hydrate,
		toJSON: n.toJSON
	};
}
function Nr() {
	return typeof crypto < "u" && "randomUUID" in crypto ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
		let t = Math.random() * 16 | 0;
		return (e === "x" ? t : t & 3 | 8).toString(16);
	});
}
//#endregion
//#region src/hooks/useAuthManager.ts
function Pr() {
	return v(Ar);
}
//#endregion
//#region src/lib/backendClient.ts
var Fr = class {
	baseUrl;
	headers;
	requester;
	requestIdManager;
	realHost;
	constructor({ baseUrl: e, headers: t, requester: n, requestIdManager: r }) {
		this.baseUrl = e, this.requester = n, this.headers = t, this.requestIdManager = r, this.realHost = new URL(this.baseUrl).hostname;
	}
	post(e, t, n) {
		let r = {
			...this.headers,
			...n?.headers,
			"content-type": "application/json",
			[D.RequestId]: this.requestIdManager.requestId.child,
			[D.Traceparent]: this.requestIdManager.traceparent,
			"x-real-host": this.realHost
		};
		return this.requester.post(e, JSON.stringify(t), {
			headers: r,
			signal: n?.signal
		}).then(({ data: e }) => e);
	}
	async get(e, t, n) {
		let r = {
			...this.headers,
			...n?.headers,
			[D.RequestId]: this.requestIdManager.requestId.child,
			[D.Traceparent]: this.requestIdManager.traceparent,
			"x-real-host": this.realHost
		}, i = t ? `${e}?${new URLSearchParams(t).toString()}` : e;
		return this.requester.get(i, {
			headers: r,
			signal: n?.signal
		}).then(({ data: e }) => e);
	}
	makeUrl(e) {
		return `${this.baseUrl}${e}`;
	}
	ref() {
		return Ir;
	}
}, Ir = b("backendClient");
//#endregion
//#region src/hooks/useBackendClient.ts
function Lr() {
	return v(Ir);
}
var Rr = { digit: "Timer_digit__XvqsT" }, zr = 1e3, Br = (e) => String(e).padStart(2, "0");
function $(e) {
	let t = Math.max(0, e);
	return {
		hours: Br(Math.floor(t / 36e5)),
		minutes: Br(Math.floor(t % 36e5 / 6e4)),
		seconds: Br(Math.floor(t % 6e4 / 1e3))
	};
}
function Vr(e) {
	let { hours: t, minutes: n, seconds: r } = $(e);
	return `${t}:${n}:${r}`;
}
var Hr = ({ durationMs: e, onExpire: t, onTick: n, className: r }) => {
	let o = l(null), s = l(null), c = l(null), u = l(t);
	u.current = t;
	let d = l(n);
	d.current = n;
	let f = i((e) => {
		let { hours: t, minutes: n, seconds: r } = $(e);
		o.current && o.current.textContent !== t && (o.current.textContent = t), s.current && s.current.textContent !== n && (s.current.textContent = n), c.current && c.current.textContent !== r && (c.current.textContent = r);
	}, []);
	a(() => {
		let t = Date.now(), n = setInterval(() => {
			let r = e - (Date.now() - t);
			r <= 0 ? (clearInterval(n), f(0), d.current?.(0), u.current?.()) : (f(r), d.current?.(r));
		}, zr);
		return () => clearInterval(n);
	}, [e, f]);
	let p = $(e);
	return /* @__PURE__ */ w("div", {
		className: r,
		dir: "ltr",
		children: [
			/* @__PURE__ */ C("span", {
				ref: o,
				className: Rr.digit,
				children: p.hours
			}),
			/* @__PURE__ */ C("span", { children: ":" }),
			/* @__PURE__ */ C("span", {
				ref: s,
				className: Rr.digit,
				children: p.minutes
			}),
			/* @__PURE__ */ C("span", { children: ":" }),
			/* @__PURE__ */ C("span", {
				ref: c,
				className: Rr.digit,
				children: p.seconds
			})
		]
	});
}, Ur = "counterOfferLastShownTimestamp", Wr = 2e4, Gr = 1440 * 60 * 1e3;
function Kr({ storage: e, hasSubscription: t, hasActiveModal: n, hasCounterOffer: r, isShowForced: i, activityEvents: o, subscribeActivity: s, delayMs: l = Wr }) {
	let u = c(() => {
		let t = x(!1), n = null, r = !0;
		return {
			visible: t.seal(),
			setBlocked(e) {
				r = e;
			},
			isCooldownActive() {
				let t = e.local.get(Ur) ?? "0";
				return Date.now() - parseInt(t, 10) < Gr;
			},
			show() {
				r || this.isCooldownActive() || (t.set(!0), e.local.set(Ur, String(Date.now())));
			},
			hide() {
				t.set(!1);
			},
			startTimer(e) {
				this.clearTimer(), n = setTimeout(() => {
					this.show();
				}, e);
			},
			clearTimer() {
				n &&= (clearTimeout(n), null);
			}
		};
	}, [e]);
	u.setBlocked(t || n || !r);
	let d = g(u.visible);
	return a(() => {
		t && (u.hide(), u.clearTimer());
	}, [t, u]), a(() => {
		i && u.show();
	}, [i, u]), a(() => {
		if (i || t || d || u.isCooldownActive()) return;
		u.startTimer(l);
		let e = () => u.startTimer(l);
		if (s) {
			let t = s(e);
			return () => {
				u.clearTimer(), t();
			};
		}
		return o.forEach((t) => document.addEventListener(t, e)), () => {
			u.clearTimer(), o.forEach((t) => document.removeEventListener(t, e));
		};
	}, [
		i,
		t,
		d,
		u,
		o,
		s,
		l
	]), {
		isVisible: d,
		hide: u.hide
	};
}
//#endregion
export { Fe as AnalyticsSenderProvider, Fr as BackendClient, Ee as EvgenLoggerDecorator, Dt as FooterComponent, Tt as PhoneInput, Nt as Picture, rt as Seo, Hr as Timer, gt as Tooltip, Se as TrackingProvider, sn as addScript, rn as appendScript, Ir as backendClientRef, jr as createAuthManager, xr as createDcbManager, Me as createEvgen, Ht as createFeatureFlags, nn as createFlagsScheme, Ve as createFromBlock, pn as createGtmService, Mr as createMDAuthManager, Cn as createMetrikaService, $n as createPayments, Bt as createPictureFactory, kn as createQueryParamsStore, Ot as createRemoteConfig, Mt as createRequestIdManager, Dr as createRivalRouteMetric, at as createUseI18n, wr as createVitalDurationMetric, Or as createVitalsManager, Tr as createWebVitalsMetric, vr as dcbManagerRef, O as evgenRef, U as featureFlagsRef, jn as formatTestIds, Vr as formatTimerValue, rr as getAutoOpenWidgetUrlFromOffer, Q as getPushUrl, Gt as getUrlFeatureFlags, q as lazyFactory, tr as parseAutoOpenWidgetParams, Yn as paymentsRef, V as remoteConfigRef, jt as requestIdManagerRef, tn as schema, it as seoDictionary, Ie as useAnalytics, Pr as useAuthManager, hr as useAutoOpenPaymentWidget, Lr as useBackendClient, ur as useCarouselPaymentPlace, Kr as useCounterOfferController, Cr as useDcbAutolink, Ne as useEvgen, Ut as useFeatureFlags, He as useFromBlock, mn as useGtmService, ot as useI18n, wn as useMetrikaService, ct as useOuterClick, cr as usePaymentPlace, An as useQueryParamsStore, j as useRelativeUrl, kt as useRemoteConfig, A as useSeoDefaults, Ue as useUpdateLocalSessionId, kr as useVitalMetric, Z as vitalsManagerRef };
